import { DecisionContext, DecisionTypeHandler, DbotEventDispatcher } from "../common/commonDomain";
import {
  ReductionOfShareCapital,
  ReductionOfShareCapitalForm,
} from "./reductionOfShareCapitalDomain";
import { DecisionType } from "../../common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext,
  data?: ReductionOfShareCapital,
): ReductionOfShareCapitalForm {
  return new ReductionOfShareCapitalForm(dispatch, context, data);
}

export function applyForm(form: ReductionOfShareCapitalForm): ReductionOfShareCapital {
  return {
    type: DecisionType.reductionOfShareCapital,
    resolutionIsBasedOnIntermediateBalanceSheet:
      form.resolutionIsBasedOnIntermediateBalanceSheetModel.value ?? false,
    intermediateBalanceSheetDate: form.intermediateBalanceSheetDateModel.validatedValue,
    reductionType: form.toReductionType(),
    reductionPurposes: form.reductionPurposeModel.selected,
    isSubsequentCapitalIncrease: form.isSubsequentCapitalIncreaseModel.value ?? false,
    amountToBePaidOutPerShare: form.affectedShareTypes.map((a) => ({
      sharetypeId: a.sharetypeId,
      amount: form.getAmounModelForSharetype(a.sharetypeId).toNumberOrZero(),
    })),
    isRepaymentOfPaidInCapital: form.isRepaymentOfPaidInCapitalModel.value ?? false,
    estimatedCosts: form.estimatedCostsModel.toNumberOrZero(),
    coverOfLossAmount: form.coverOfLossAmountModel.toNumberOrZero(),
    transferToOtherFundsAmount: form.transferToOtherFundsModel.toNumberOrZero(),
    distributeToShareholdersAmount: form.distributeToShareholdersModel.toNumberOrZero(),
    cancellationOfOwnSharesAmount: form.calculateCancellationOfOwnSharesAmount,
    updateArticlesAutomatically: form.updateArticlesAutomatically.value,
    articleOfAssociationNumber: form.articleOfAssociationNumberModel.selected ?? 0,
    articleChanges: form.articleChangeModel.articleChanges.map((d) => d),
    circumstances: form.circumstancesModel.value,
    circumstancesExplanation: form.mapCirumstancesExplanationModel,
    circumstancesMaterialImportance: form.circumstancesMaterialImportanceModel.value,
    circumstancesMaterialImportanceExplanation:
      form.mapCircumstancesMaterialImportanceExplanationModel,
    capitalReductionAccountsType: form.annualAccountInterimBalanceSheetModel.value,
    dateOfDetermination: form.dateOfDetermination.validatedValue,
  };
}

export function validate(form: ReductionOfShareCapitalForm) {
  return form.validate();
}

export function isValid(form: ReductionOfShareCapitalForm) {
  return form.isValid;
}

export const reductionOfShareCapitalHandler: DecisionTypeHandler<
  DecisionType.reductionOfShareCapital,
  ReductionOfShareCapital,
  ReductionOfShareCapitalForm
> = {
  type: DecisionType.reductionOfShareCapital,
  initNewForm,
  isValid,
  validate,
  applyForm,
  handleEvent(form, event) {
    form.handleEvent(event);
  },
};
